import type { ReactElement } from 'react';
import styles from './Loading.module.scss';

/** Индикатор загрузки экрана или блока. */
export function Loading({ label }: { label: string }): ReactElement {
  return (
    <div className={styles.loading} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
